import { createSelector } from 'reselect';
import { RootState } from '../root.reducer';
import { AppState } from './types';

const selectCache = (state: RootState) => state.app;

export const selectTheme = createSelector(
  selectCache,
  (cache: AppState) => cache.theme
);

export const selectLang = createSelector(
  selectCache,
  (cache: AppState) => cache.language
);

export const selectHeaderPanelExpand = createSelector(
  selectCache,
  (cache: AppState) => cache.headerPanelExpand
);

export const selectPivateTeamBaseMap = createSelector(
  selectCache,
  (cache: AppState) => cache.privateTeamBaseMap
);
